import { useParams } from "react-router-dom";
import { useGetServiceMonthlyAvailablity } from "../../../../hooks/api/queries";
import { CalendarView } from "./CalendarView";
import styles from "./styles.module.scss";
import { useEffect, useMemo, useState } from "react";
import { BookingSummary } from "./BookingSummary";
import { TimeView } from "./TimeView";
import { RoutedModal } from "../../../common";
import { setToDateMonthYearInWordsByOnLocal } from "../../../../helpers";
import { useCart } from "../../../../hooks/useCart";

export const ServiceDetails = ({ serviceDetails = {} }) => {
  const { service_id, store_id } = useParams();
  const { cartItems = [] } = useCart({});
  const isService = !!serviceDetails?.is_service;
  const existingItem = useMemo(() => {
    return cartItems.find(
      (item) =>
        String(item?.id) === String(service_id) &&
        item?.is_service === isService,
    );
  }, [cartItems, service_id, isService]);
  const [queryParams, setQueryParams] = useState({
    store_id,
  });
  const [bookDetails, setBookDetails] = useState(() => ({
    active_booking_date: null,
    bookings: existingItem?.bookings || [],
  }));
  useEffect(() => {
    if (existingItem?.bookings?.length) {
      setBookDetails((prev) => {
        // Do not overwrite active in-progress edits
        if (prev.bookings.length) return prev;

        return {
          ...prev,
          bookings: existingItem.bookings,
        };
      });
    }
  }, [existingItem?.bookings]);

  const { data } = useGetServiceMonthlyAvailablity({
    queryParams,
    service_id,
  });

  const closeModal = () => {
    setBookDetails((prev) => ({
      ...prev,
      active_booking_date: null,
    }));
  };

  return (
    <>
      <div className={styles.serviceDetails}>
        <div className={styles.serviceDetails__calendar}>
          <CalendarView
            availability={data}
            setQueryParams={setQueryParams}
            bookDetails={bookDetails}
            setBookDetails={setBookDetails}
          />
        </div>

        <div className={styles.serviceDetails__booking_summary}>
          <BookingSummary
            serviceDetails={serviceDetails}
            bookDetails={bookDetails}
            setBookDetails={setBookDetails}
          />
        </div>
      </div>

      <RoutedModal
        isActive={Boolean(bookDetails.active_booking_date)}
        width={1200}
        headerTitle={
          <span className={`d-flex mb-2 ${styles.modalTitle}`}>
            <span className="gray--text font-weight-normal">
              Time Slots for:
            </span>
            <span className="ml-2 font-weight-normal">
              {setToDateMonthYearInWordsByOnLocal(
                bookDetails.active_booking_date,
              )}
            </span>
          </span>
        }
        headerDescription="Select reservation from the available slots."
        closeModal={closeModal}
      >
        <TimeView
          bookDetails={bookDetails}
          setBookDetails={setBookDetails}
          closeModal={closeModal}
        />
      </RoutedModal>
    </>
  );
};
